import React from 'react';
import { Button, Picture } from '@udemy/react-core-components';
import { tokens } from '@udemy/styles';
import styles from "./hero-banner-slide.module.css";
export const HeroBannerSlideLayoutType = {
  SPLIT: 'split',
  WIDE: 'wide',
  WIDE_DARK: 'wide-dark'
};

/** React prop interface for the `HeroBannerSlide` component */

/**
 * ### HeroBannerSlide
 *
 * An individual slide for use within the `HeroBanner` component.
 */
export const HeroBannerSlide = ({
  button1Href,
  button1OnClick,
  button1Text,
  button1Target = '_self',
  button2Href,
  button2OnClick,
  button2Target = '_blank',
  button2Text,
  imageWide,
  ...props
}) => {
  const imageWideSource = {
    srcSet: imageWide.src,
    width: imageWide.width,
    height: imageWide.height,
    media: `(max-width: ${tokens['breakpoint-md-max']})`
  };
  return /*#__PURE__*/React.createElement("section", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['heading-container']
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.title,
    dangerouslySetInnerHTML: {
      __html: props.title
    }
  }), /*#__PURE__*/React.createElement("h3", {
    className: styles.subtitle,
    dangerouslySetInnerHTML: {
      __html: props.subtitle
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['button-container']
  }, button1Href && button1Text && /*#__PURE__*/React.createElement(Button, Object.assign({
    className: styles.button,
    componentClass: "a",
    href: button1Href,
    onClick: button1OnClick,
    target: button1Target
  }, button1Target === '_blank' && {
    rel: 'noopener'
  }), button1Text), button2Href && button2Text && /*#__PURE__*/React.createElement(Button, Object.assign({
    className: styles.button,
    componentClass: "a",
    href: button2Href,
    onClick: button2OnClick,
    udStyle: "secondary",
    target: button2Target
  }, button2Target === '_blank' && {
    rel: 'noopener'
  }), button2Text))), /*#__PURE__*/React.createElement("div", {
    className: styles['image-container']
  }, /*#__PURE__*/React.createElement(Picture, Object.assign({
    imgClassName: styles.image
  }, props.imageSquare, {
    sources: [imageWideSource]
  }))));
};
//# sourceMappingURL=hero-banner-slide.react-component.js.map